/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.uber.conference.rpc.AccountRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type HubSpotOwnedIntegration =
  | 'DEV_HUB_TEST_APP'
  | 'EVENTBRITE'
  | 'GOOGLE_CALENDAR'
  | 'GO_TO_WEBINAR'
  | 'SURVEY_MONKEY'
  | 'UBER_CONFERENCE'
  | 'WISTIA'
  | 'SALESFORCE'
  | 'LINKEDIN_SALES_NAVIGATOR'
  | 'SHOPIFY'
  | 'SLACK'
  | 'GOOGLE_SEARCH_CONSOLE'
  | 'ZOOM'
  | 'GOOGLE_SHEETS'
  | 'VIDYARD'
  | 'OFFICE_365_CALENDAR'
  | 'QUICK_BOOKS_ONLINE'
  | 'MAILCHIMP'
  | 'MICROSOFT_DYNAMICS_365'
  | 'DATA_AUDITOR_DYNAMICS_365'
  | 'NETSUITE'
  | 'JIRA'
  | 'MSTEAMS'
  | 'GOOGLE_MEET'
  | 'DOCUSIGN'
  | 'AIRTABLE'
  | 'TRELLO'
  | 'ONE_SIGNAL'
  | 'ZOHO'
  | 'PIPEDRIVE'
  | 'COPPER'
  | 'ZOOM_APPS'
  | 'ACTIVE_CAMPAIGN'
  | 'KEAP'
  | 'GOOGLE_CONTACTS'
  | 'DATASYNC'
  | 'GOOGLE_CHAT'
  | 'GOOGLE_DRIVE'
  | unhandledEnumCase;

export type HubSpotOwnedIntegrationStatus = {
  hubSpotOwnedIntegration: HubSpotOwnedIntegration;
  integrationStatus: IntegrationStatus;
};

export type HubSpotOwnedIntegrationStatusResponse = {
  hubSpotOwnedIntegration: HubSpotOwnedIntegration;
  integrationStatus: IntegrationStatus;
  integrationStatusError?: IntegrationStatusError;
  integrationStatusMetadata?: IntegrationStatusMetadata;
};

export type IntegrationErrorCta =
  | 'RECONNECT'
  | 'RENEW_LICENSE_AND_RECONNECT'
  | 'CONTACT_SUPPORT'
  | 'RESOLVE_IN_SETTINGS'
  | 'RESUME'
  | 'REVOKE_TOKEN_AND_RECONNECT'
  | unhandledEnumCase;

export type IntegrationStatus =
  | 'INTEGRATED'
  | 'INTEGRATED_AND_DISABLED'
  | 'NOT_INTEGRATED'
  | 'REAUTHORIZE'
  | 'WARNING'
  | 'ERROR'
  | 'CONNECTED'
  | 'USER_DISABLED'
  | 'AUTH_ERROR'
  | 'THIRD_PARTY_AVAILABILITY_ERROR'
  | 'THIRD_PARTY_LICENSE_ERROR'
  | 'THIRD_PARTY_MISSING_SCOPE_ERROR'
  | 'UNKNOWN_ERROR'
  | 'DELAY'
  | 'DEPRECATED_AUTH_TOKEN'
  | unhandledEnumCase;

export type IntegrationStatusError = {
  integrationErrorCta: IntegrationErrorCta;
  errorMessage?: string;
};

export type IntegrationStatusMetadata = { user?: string; timestamp?: number };

export type BuildOAuthUrlRequest = { baseRedirectUrl: string };

export type BuildOAuthUrlResponse = { location: string };

export type CheckInstalledResponse = { enabled: boolean };

export type ConnectRequest = {
  baseRedirectUrl: string;
  oAuthCodeHolder: OAuthCodeWrapper;
};

export type ConnectResponse = {};

export type DisconnectForPortalByUserResponse = {};

export type DisconnectResponse = {};

export type OAuthCodeWrapper = { code: string };

export type BuildOAuthUrlRequestType = Requestify<BuildOAuthUrlRequest>;
export type BuildOAuthUrlResponseType = BuildOAuthUrlResponse;
export type BuildOAuthUrlErrorType = EmptyError & HubspotMetadata;
export const buildOAuthUrlRpc: ChirpAvroRpcDetails<
  BuildOAuthUrlRequestType,
  BuildOAuthUrlResponseType,
  BuildOAuthUrlErrorType,
  false
> = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'buildOAuthUrl',
  auth: 'app',
  fingerprint: 'slGYIcMJVtjb0NjvAexiDZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CheckInstalledResponseType = CheckInstalledResponse;
export type CheckInstalledErrorType = EmptyError & HubspotMetadata;
export const checkInstalledRpc: ChirpAvroRpcDetails<
  undefined,
  CheckInstalledResponseType,
  CheckInstalledErrorType,
  false
> = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'checkInstalled',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAyGuRJnzYclJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ConnectRequestType = Requestify<ConnectRequest>;
export type ConnectResponseType = ConnectResponse;
export type ConnectErrorType = EmptyError & HubspotMetadata;
export const connectRpc: ChirpAvroRpcDetails<
  ConnectRequestType,
  ConnectResponseType,
  ConnectErrorType,
  false
> = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'connect',
  auth: 'app',
  fingerprint: 'GkDtp6P5DWSlbwcxSM77JpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DisconnectResponseType = DisconnectResponse;
export type DisconnectErrorType = EmptyError & HubspotMetadata;
export const disconnectRpc: ChirpAvroRpcDetails<
  undefined,
  DisconnectResponseType,
  DisconnectErrorType,
  false
> = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'disconnect',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACslsmQdtrL25wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DisconnectForPortalByUserResponseType =
  DisconnectForPortalByUserResponse;
export type DisconnectForPortalByUserErrorType = EmptyError & HubspotMetadata;
export const disconnectForPortalByUserRpc: ChirpAvroRpcDetails<
  undefined,
  DisconnectForPortalByUserResponseType,
  DisconnectForPortalByUserErrorType,
  false
> = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'disconnectForPortalByUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADpz_mrNA0EWZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetConnectionStatusResponseType =
  HubSpotOwnedIntegrationStatusResponse;
export type GetConnectionStatusErrorType = EmptyError & HubspotMetadata;
export const getConnectionStatusRpc: ChirpAvroRpcDetails<
  undefined,
  GetConnectionStatusResponseType,
  GetConnectionStatusErrorType,
  false
> = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'getConnectionStatus',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACkt4BJabzyGZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetStatusResponseType = HubSpotOwnedIntegrationStatus;
export type GetStatusErrorType = EmptyError & HubspotMetadata;
export const getStatusRpc: ChirpAvroRpcDetails<
  undefined,
  GetStatusResponseType,
  GetStatusErrorType,
  false
> = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'getStatus',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACXKHOjOb7co5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
